export interface IVectronConfigState {
  defaultPosMenu: boolean;
  defaultSalesRoom: boolean;
  defaultEmployee: boolean;
  posliteScreenConfig: boolean;
}
